import * as types from './mutations-types';
import { defaultState } from './state';

import moment from 'moment';
const resetState_ = state => {
	Object.assign(state, defaultState);
};
const defaultSelect = (state, { optionNm, valueNm }) => {
	state[valueNm] = state[optionNm][0]['value'];
};

const changeValue = (state, data) => {
	if (data.name == 'searchMonth') data.value = moment(data.value).format('YYYY-MM');
	state[`${data.name}`] = data.value;
};

export default {
	resetState_,
	defaultSelect,
	changeValue,
	[types.DEFAULT_ASSIGN]: (state, payload) => {
		state[payload.key] = payload.value;
	}
};
